 angular.module('trainerWebApp.consts').constant('hqTypes', {
  Errors: {
    SyncFailure: {
      Title: 'HQ Sync Error',
      Message: "There was an error syncing the user details with MitratechHQ, we've been notified and are working to resolve the issue."
    }
  }
});
